import styled from "styled-components";
import { DeleteModalStyled } from "../../../../../../components/modal-component/modal-component.styles";

export const GiveAccessModalBodyStyled = styled(DeleteModalStyled)`
    .confirm-button {
        background-color: #2460B8 !important;
    }
`
